import { render } from "./EmployeeProcess25Liquidation.vue?vue&type=template&id=4b38bfb0"
import script from "./EmployeeProcess25Liquidation.vue?vue&type=script&lang=js"
export * from "./EmployeeProcess25Liquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__